// core/configs/AuthProvider.tsx
import { createContext, useContext, ReactNode } from 'react'
import { useOidcAuth } from './oicdAuth'
import {isBridgeAvailable, useBookmapAuth} from './bookmapBridge'

type AuthMode = 'bookmap' | 'oidc'

interface AuthContextValue {
    mode: AuthMode
    isLoading: boolean
    isAuthenticated: boolean
    signinRedirect: () => void
    signoutRedirect: () => void
}

const AuthContext = createContext<AuthContextValue | null>(null)

export function AuthProvider({ children }: { children: ReactNode }) {
    const bookmap = useBookmapAuth()
    const oidc = useOidcAuth()

    const mode: AuthMode = isBridgeAvailable() !== false && bookmap.status !== 'unavailable' ? 'bookmap' : 'oidc'

    const isLoading = bookmap.status === 'checking' || (mode === 'oidc' && oidc.isLoading)

    const isAuthenticated =
        mode === 'bookmap' ? bookmap.status === 'authenticated' : oidc.isAuthenticated

    const value: AuthContextValue = {
        mode,
        isLoading,
        isAuthenticated,
        signinRedirect: oidc.signinRedirect,
        signoutRedirect: oidc.signoutRedirect,
    }

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuth() {
    const ctx = useContext(AuthContext)
    if (!ctx) throw new Error('useAuth must be used within AuthProvider')
    return ctx
}